import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PaymentModal from './PaymentModal'; 

const SubscribeButton = ({ postId, price, walletBalance }) => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const handleSubscribeClick = () => {
    document.body.classList.add('show-payment-modal'); // Add class to body
    setShowPaymentModal(true); // Open payment modal on button click
  };

  return (
    <>
    
      <div className="post_subscribe_btn">  
        <Link
          className="subscription_btn"
          onClick={handleSubscribeClick}
        ><span>Unlock Post for ${price}</span> 
        </Link> 
      </div>

      {showPaymentModal && ( 
        <PaymentModal
          postId={postId}
          price={price}
          walletBalance={walletBalance}
          onClose={() => setShowPaymentModal(false)}
        />        
      )}

    </>
  );
};

SubscribeButton.propTypes = {
  postId: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
};

export default SubscribeButton;
